$(document).ready(function () {
    var slider = $('[data-toggle=slick-vertical]'),
        nav = $('.navbar'),
        current = 0,
        last = slider.children().length - 1,

        menu = $('nav.navbar'),
        menuItems = menu.find('li > a'),
        scrollItems = [],
        scrollTo = function(hash) { 
            var slide = $(hash).closest('[data-slick-index]');

            if (!slide.length) return;

            slider.slick('slickGoTo', slide.data('slick-index'));
        }
        ;

    /* HANDLE SCROLL */
    var animationTime = 1200, // Making the time less than 1200ms can break custom scroll see wheel event comments
        animating = false,
        footerIsCurrent = false,
        prevTime = new Date().getTime(),
        scrollings = []
        ;

    slider
        .off('init').on('init', function () {
            current = 0;

            $('html').addClass('no-scroll');

            scrollItems = menuItems.map(function() {
                var hash = $(this).prop('hash');
                var item = $(hash);
    
                if (item.length) return { hash: hash, slide: item.closest('[data-slick-index]').attr('data-slick-index') };
            });

            slider.off('beforeChange').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                // show shadow when scrolled
                nav.toggleClass('navbar-shadow', nextSlide != 0);
    
                // scrollspy
                var cur = scrollItems.map(function() {
                    if (this.slide == nextSlide) return this.hash;
                });
    
                var hash = cur && cur.length ? cur[0] : '';
    
                menuItems.parent().removeClass('active')
                .end().filter('[href*="' + (hash || '_') + '"]').parent().addClass("active");

                current = nextSlide;
            });

            slider.off('afterChange').on('afterChange', function () {
                animating = false; // This indicates that slick slide animation is done, see scroll events below
            });


            /**
              * Gets the average of the last `number` elements of the given array.
            */
             var getRunningAverage = function(elements, number) {
                var sum = 0;

                var lastElements = elements.slice(Math.max(elements.length - number, 1));

                for (var i = 0; i < lastElements.length; i++)
                    sum = sum + lastElements[i];

                return Math.ceil(sum / number);
            };

            /* HANDLE SCROLL ON SLICK */
            /* 
                The issue is that wheel event is sent in rapid succession when a fling gesture is performed on touchpad
                so this logic detects if event was sent by human or is a subsequent attempt to immitate smooth scrolling by hardware
            */
            slider.off('wheel').on('wheel', function(ev) {
                ev.preventDefault();

                var curTime = new Date().getTime();

                var e = ev.originalEvent;
                e = e || window.event;
                var value = e.wheelDelta || -e.deltaY || -e.detail;
                var delta = Math.max(-1, Math.min(1, value));

                var horizontalDetection = typeof e.wheelDeltaX !== 'undefined' || typeof e.deltaX !== 'undefined';
                var isScrollingVertically = (Math.abs(e.wheelDeltaX) < Math.abs(e.wheelDelta)) || (Math.abs(e.deltaX ) < Math.abs(e.deltaY) || !horizontalDetection);

                if (scrollings.length > 149) scrollings.shift();

                scrollings.push(Math.abs(value));

                var timeDiff = curTime - prevTime;
                prevTime = curTime;

                if (timeDiff > 200) scrollings = [];

                if (!animating) {
                    var down = delta < 0;

                    var averageEnd = getRunningAverage(scrollings, 10);
                    var averageMiddle = getRunningAverage(scrollings, 70);
                    var isAccelerating = averageEnd >= averageMiddle;

                    // To avoid double swipes...
                    if (isAccelerating && isScrollingVertically) {
                        animating = true;
                    
                        if (last == current && down) {
                            // Scroll to footer
                            $('html, body').stop().animate({
                                scrollTop: document.body.scrollHeight,
                            }, animationTime, function () {
                                animating = false;
                                footerIsCurrent = true;
                            });
                        } else if (last == current && !down && footerIsCurrent) {
                            // Scroll to top (user sent wheel event on last slide while footer is visible)
                            $('html, body').stop().animate({
                                scrollTop: 0,
                            }, animationTime, function () {
                                animating = false;
                                footerIsCurrent = false;
                            });
                        } else {
                            // Normal slide switch
                            window.scrollTo(0, 0);
        
                            $(this).slick(down ? 'slickNext' : 'slickPrev');
                        }
                    }
                }

                return false;
            });

            /* HANDLE SCROLL ON FOOTER */
            $('footer').off('wheel').on('wheel', function (ev) {
                ev.preventDefault();

                if (animating) return false;

                var e = ev.originalEvent;
                var value = e.wheelDelta || -e.deltaY || -e.detail;
                var delta = Math.max(-1, Math.min(1, value));
                var down = delta < 0;

                animating = true;

                $('html, body').stop().animate({
                    scrollTop: down ? document.body.scrollHeight : 0,
                }, animationTime, function () {
                    animating = false;

                    if (!down) footerIsCurrent = false;
                });

                return false;
            });

            /* handle menu item click */
            $(menuItems).off('click').on('click', function(ev) {
                ev.preventDefault();

                $('#navbar-nav').removeClass('show');

                var hash = $(this).prop('hash');

                window.scrollTo(0, 0);

                scrollTo(hash);
            });
        })
        .off('destroy').on('destroy', function () {
            $('html').removeClass('no-scroll');

            slider.off('beforeChange');

            /* handle scroll */
            slider.off('wheel');

            /* handle menu item click */
            $(menuItems).off('click');
        });


    if (location.hash) {
        var hash = location.hash;
        location.hash = '';
        setTimeout(function () { scrollTo(hash); }, 100);
    }
    
    function slickify() {
        if ($(window).width() <= 1199)  {
            menuItems.on('click', function() {
                $('.navbar-collapse').collapse('hide');
            });
        } else {
        
            slider.not('.slick-initialized').slick({
                vertical: true,
                verticalSwiping: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                arrows: false,
                centerMode: true,
                centerPadding: '1px',
                speed: animationTime,
                accessibility: false,
                responsive: [
                    {
                        breakpoint: 1199,
                        settings: 'unslick'
                    }
                ]
            });
        }
    };

    slickify();

    $(window).resize(function() {
        slickify();
    });

    $('button, a').attr('tabindex', '-1');
    $('form button, form a').attr('tabindex', '0');
});